import type { ITaskRepository } from "@src/domain/pascos/repository/task_repository";
import type { TaskDTO } from "../dto";
import { TaskDtoMapper } from "../mappers/task-dto.mapper";

/**
 * Use Case: Get Task by ID
 * Retrieves a specific task by its unique identifier
 */
export class GetTaskByIdUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    /**
     * Execute the use case
     * @param taskId - The unique identifier of the task
     * @returns Promise<TaskDTO> - The task data
     */
    async execute(taskId: string): Promise<TaskDTO> {
        const task = await this.taskRepository.getTaskStatus(taskId);
        return TaskDtoMapper.toDTO(task);
    }
}
